var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.5 0.874268H37.6343L24.2343 16.2286L40 37.1257H27.6571L17.9829 24.4543L6.92571 37.1257H0.785714L15.1171 20.6971L0 0.877125H12.6571L21.3886 12.4571L31.5 0.874268ZM29.3429 33.4457H32.7429L10.8 4.36284H7.15429L29.3429 33.4457Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterX);
export default __webpack_public_path__ + "static/media/footer-x.b32f9aca898eb8895f038e1ee2e0d92d.svg";
export { ForwardRef as ReactComponent };